module.exports = __webpack_public_path__ + "static/media/avatar_monkey.47745e1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_monkey.png
// module id = 389
// module chunks = 0